import React from 'react';

const TripPlanner = () => (
    <div />
    /*<div className="trip-planner">
        <h1 className="trip-planner__title">Kuhu lähme?</h1>
    </div>*/
);

export default TripPlanner;



// WEBPACK FOOTER //
// ./src/views/TripPlanner.js